import ENV from "./env";
import { app_version } from "./tool";

var ua = window.navigator.userAgent
    ,is_webview = /afdian/.test(ua)
    ,is_ios = /iPhone OS/.test(ua)
    ,is_android = /[aA]ndroid/.test(ua)
    ,is_mobile = /Mobile/.test(ua)

var android_bridge = null;

function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
}

function connectWebViewJavascriptBridge(callback) {
    if(android_bridge){
        callback(android_bridge)
        return false
    }

    if (window.WebViewJavascriptBridge) {
        WebViewJavascriptBridge.init(function(message, responseCallback) {})
        android_bridge = WebViewJavascriptBridge
        callback(android_bridge)
    } else {
        document.addEventListener(
            'WebViewJavascriptBridgeReady'
            , function() {
                WebViewJavascriptBridge.init(function(message, responseCallback) {})
                android_bridge = WebViewJavascriptBridge
                callback(android_bridge)
            },
            false
        );
    }
}
//注册回调函数，第一次连接时调用 初始化函数
// connectWebViewJavascriptBridge()


var Bridge = function () {}
Bridge.prototype = {
    call:function (api, data, callback) {
        var d = data,
            c = callback;
        console.log(api)
        console.log(d)
        if(Object.prototype.toString.call(data) == '[object Function]'){
            d = {};
            c = data;
        }
        if(is_ios){
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler(api, d, function(response) {
                    if(response){
                        console.log(response)
                    }
                    c(response)
                })
            })
        }else{
            connectWebViewJavascriptBridge(function (bridge) {
                if(api == 'history_close' && app_version("0.0.31") == "lower"){
                    api = 'closePage';
                }
                bridge.callHandler(api, d, function(response) {
                        if(response){
                            console.log(response)
                        }
                        c(JSON.parse(response))
                    }
                );
            })
        }

    },
    on:function (event_name, callback) {
        console.log(event_name)
        if(is_ios) {
            setupWebViewJavascriptBridge(function(bridge) {
                bridge.registerHandler(event_name, function(data, responseCallback) {
                    callback(data)
                    responseCallback({ec:200,em: 'js called'});
                })
            })
        }else {
            //接收安卓发来的消息   并返回给安卓通知
            // connectWebViewJavascriptBridge(function (bridge) {
            //     bridge.registerHandler(event_name, function(data, responseCallback) {
            //         callback(data)
            //         responseCallback({ec:200,em: 'js called'});
            //     });
            // })
            // connectWebViewJavascriptBridge(function(bridge) {
            //     try{ //此处try catch注意  android 有init初始化方法，必须调用 不调用后续注册的事件将无效 而IOS却没有init方法 调用会报错 所以得捕获异常
            //         bridge.init(function(message, responseCallback) {
            //             console.log('JS got a message', message);
            //             var data = {
            //                 'Javascript Responds': '测试中文!'
            //             };
            //             responseCallback(data);
            //         });
            //     }catch(e){
            //
            //     }
            //
            //
            // })
        }

    }
}
export default new Bridge()
